<template>
<div>
  <div>
    <div class="box" v-bind:style="background">
      <Title :title="title" :message="message"/>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/bus-content-1.jpg"/>
          <div class="disc-caption">
            <a>49人乗（補助席込53人乗）中二階タイプ</a>
          </div>
        </div>
        <div class="col-xs-12 col-lg-5 order-md-first disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                車両案内
              </div>
              選べるバスは、
              25人乗りから60人乗りまで。
              どれも最新型を揃えています。
            </div>
            <table class="table type-table">
              <tbody>
                <tr>
                  <th>49人<a>乗</a></th>
                  <td>｜補助席込60人乗
                  ｜補助席込50人乗スーパーハイデッカー
                  </td>
                </tr>
                <tr>
                  <th class="no-border">45人<a>乗</a></th>
                  <td class="no-border">｜補助席込53人乗
                    ｜補助席込52人乗スーパーハイデッカー
                  </td>
                </tr>
                <tr>
                  <th class="no-border">33人<a>乗</a></th>
                  <td class="no-border">｜補助席込39人乗</td>
                </tr>
                <tr>
                  <th class="no-border">28人<a>乗</a></th>
                  <td class="no-border">｜補助席なし</td>
                </tr>
                <tr>
                  <th class="no-border">25人<a>乗</a></th>
                  <td class="no-border">｜補助席なし</td>
                </tr>
              </tbody>
            </table>
            <a href="https://toei.myweb.co.jp/bus/pamphlet.pdf" class="box4">
              <p>パンフレットPDFのダウンロード</p>
              <div class="arrow01"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/bus-content-2.jpg"/>
        </div>
        <div class="col-xs-12 col-lg-5 resizeimage disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                車両設備
              </div>
              安全装備も業界最高水準。
              どんな道でも安心して
              お乗りいただけます。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="text">車間クルーズ機能
                    衝突被害軽減ブレーキ（PCS）
                    衝突後制動機能
                    衝突回避支援機能
                    ドライバーモニター
                    車線逸脱警報装置
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="disc-caption">
            <a>※車両設備は車種ごとに異なります。</a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/bus-content-3.jpg"/>
        </div>
        <div class="col-xs-12 col-lg-5 order-md-first resizeimage disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                認定
              </div>
              貸切バス安全性評価★★★
              業界最長、8年連続最高評価を
              受けています。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="text">当社は貸切バス事業者安全性評価認定制度（セーフティバス）★★★認定を受けています。 認定制度開始時より現在まで最高評価を継続している事業者は、全体のおよそ3%しかありません。</td>
                </tr>
              </tbody>
            </table>
            <router-link class="box4" to="/safety">
              <p>当社の安全への取り組み</p>
              <div class="arrow01"></div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/bus-content-4.jpg"/>
        </div>
        <div class="col-xs-12 col-lg-5 resizeimage disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                車両装備
              </div>
              それぞれの旅にあった、
              それぞれの設備を
              お楽しみください。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="text">テレビモニター
                    CD/DVDデッキ
                    カラオケ
                    冷蔵庫
                    湯沸設備
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="disc-caption">
            <a>※車内設備のご利用希望の際は、予約時にお申し付けください。</a>
          </div>
        </div>
      </div>
    </div>
    <div class="container contact-container">
      <div class="caption">
        貸切バスのお見積り
      </div>
      <div class="row contact-box">
        <div class="col-xs-12 col-lg-6">
          <p>お電話にてお問い合わせ下さい</p>
        </div>
        <div class="col-xs-12 col-lg-6">
          <p class="tel">03-3965-0556</p>
        </div>
      </div>
      <div class="row office-box">
        <div class="col-xs-12 col-lg-6 contact">
          <span>東京営業所</span>
          〒174-0051 東京都板橋区小豆沢2-3-11
          T:03-3965-0556｜F:03-3965-0557
        </div>
        <div class="col-xs-12 col-lg-6 contact">
          <span>横浜営業所</span>
          〒223-0057 神奈川県横浜市港北区新羽町1187
          T:045-540-2710｜F:045-531-8965
        </div>
      </div>
      <div class="row office-box">
        <div class="col-xs-12 col-lg-6 contact">
          <span>大宮営業所</span>
          〒331-0811 埼玉県さいたま市北区吉野町2-3-4
          T:048-653-0050｜F:048-652-1248
        </div>
        <div class="col-xs-12 col-lg-6 contact">
          <span>さいたま第二営業所</span>
          〒339-0011 埼玉県さいたま市岩槻区長宮94
          T:048-799-1214｜F:048-799-1088
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Title from '@/components/Title.vue'

export default {
  components: {
    Title
  },
  data () {
    return {
      background: {
        background: '',
        position: 'relative',
        height: '100vh',
        minHeight: '300px',
        backgroundSize: 'cover',

        display: 'flex',
        flexDirection: 'column',

        letterSpacing: '0',
        color: '#FFFFFF'
      },
      title: 'BUS',
      message: '1台ごとに色の異なる、カラフルなプードルバス'
    }
  },
  created () {
    this.background.background = "url('" + require('../assets/bus.jpg') + "') no-repeat 70% 50%"
  }
}
</script>

<style scoped>
.content {
  padding-top: 5%;
  max-width: 1280px;
}
.content .row {
  align-items: center;
}
.table-container {
  padding: 2% 4% 4% 4%;
  white-space: pre-line;
}
.table-container.last {
  padding-bottom: 40px;
}
.table td {
  color: #000000;
  vertical-align: middle;
}
.table th {
  font-size: 34px;
    color: #000000;
  vertical-align: middle;
}
@media screen and (max-width: 1280px) {
  .type-table td {
    color: #000000;
    vertical-align: middle;
    font-size: 12px;
    padding-left: 0;
    padding-right: 0;
  }
  .type-table th {
    padding-left: 7px;
    padding-right: 0;
    font-size: 24px;
    color: #000000;
    width: 26%;
    vertical-align: middle;
  }
}
.table a{
  font-size: 16px;
}
.table .no-border {
  border-top: none;
}
.text {
  font-size: 16px;
}
.table-title {
  color: #000000;
  font-size: 32px;
  font-weight: bold;
  padding-bottom: 20px;
  position: relative;
}
.table-caption {
  position: absolute;
  top: -16%;
  font-size: 16px;
  color: #6F6B6B;
  font-weight: normal;
}
.box4 {
  border: 2px solid #7E7474;
  padding: 5px 14px;
  margin-top: 20px;
  margin-bottom: 11px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box4 p {
  font-size: 20px!important;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.arrow01 {
  display: block;
  width: 12px;
  height: 12px;
  border-top: solid 3px #7E7474;
  border-right: solid 3px #7E7474;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: 13%;
}
.caption {
  position: absolute;
  top: 0%;
  font-size: 16px;
  color: #6F6B6B;
  font-weight: normal;
}
.resizeimage {
  padding-right: 0px;
  padding-left: 0px;
  text-align: end;
  min-width: 240px;
}
.resizeimage img {
  width: 100%;
}
.resizeimage a {
  font-size: 10px;
  padding-right: 2%;
}
.disc {
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: left;
}
.disc-caption {
  text-align: end;
}
.contact-container {
  padding-top: 40px;
  padding-bottom: 40px;
  white-space: pre-line;
  position: relative;
}
.contact-box {
  border: 2px solid #7E7474;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 75px 20px 75px 20px;
  margin-top: 20px;
  margin-bottom: 11px;
  margin-left: 0px;
  margin-right: 0px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  text-align: center;
}
.contact-box p {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.contact-box p.tel {
  font-size: 36px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.office-box {
  padding: 0px 10% 0px 12%;
}
@media screen and (max-width: 480px) {
  .office-box {
    padding: 0px 0px 0px 0px;
  }
  .contact {
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 16px;
  }
  .contact span {
    font-size: 17px;
  }
  .resizeimage {
    padding-right: 5%;
    padding-left: 5%;
  }
  .table-title {
    font-size: 22px;
  }
}
.contact {
  padding-top: 12px;
  padding-bottom: 12px;
}
.contact span {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/Bus.vue